import React, { useState, useEffect } from "react";
import { Layout } from "../../GlobalComponent/Layout/Layout";
import { Box, Text } from "@chakra-ui/react";
import ViewAmbulance from "./components/ViewAmbulance";
import DownloadAmbulanceCoverage from "./components/Download";


const AmbulanceCoverage: React.FC = () => {
    const [view, setView] = useState(() => {
        const saved = localStorage.getItem('ambulanceCoverageView');
        return saved ? JSON.parse(saved) : true;
    });

    useEffect(() => {
        localStorage.setItem('ambulanceCoverageView', JSON.stringify(view));
    }, [view]);
    return (
        <Layout>
            <Box display={"flex"} justifyContent={"space-between"} mt={"10px"} mb={"20px"} width={"-moz-max-content"} maxWidth={"35%"} ml={"30px"} >
                <Text
                    fontSize={"md"}
                    onClick={() => setView(true)}
                    color={view ? "blue.500" : "gray.600"}
                    fontWeight={view ? "bold" : "normal"}
                    cursor="pointer"
                >
                    View Ambulance Coverage
                </Text>
                <Text
                    fontSize="md"
                    onClick={() => setView(false)}
                    color={!view ? "blue.500" : "gray.600"}
                    fontWeight={!view ? "bold" : "normal"}
                    cursor="pointer"
                >
                    Initiate and Download Coverage Report
                </Text>
            </Box>
            <Box>
                {view ? (<ViewAmbulance />) : (<DownloadAmbulanceCoverage />)}
            </Box>

        </Layout>

    );
}



export default AmbulanceCoverage;